module.exports = __webpack_public_path__ + "static/img/7.63761b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7.jpg
// module id = 9148
// module chunks = 1